import i18n from "../../../../utils/i18n";
import {
  buildProviderExperienceTags,
  getProviderBookkeepieTenureLabel,
  getProviderReviewDisplay,
  getQuickResultProviderDisplayName,
  getQuickResultProviderKey,
} from "./quickResultProviders";
import QuickResultStarRating from "./QuickResultStarRating";
import classes from "./quickResultProviderCard.module.scss";

const QuickResultProviderCard = ({ provider, providerKey, selectedIndustry }) => {
  const stableProviderKey = providerKey ?? getQuickResultProviderKey(provider);
  const { avg: reviewAvg, count: reviewCount } = getProviderReviewDisplay(provider);
  const tenureLabel = getProviderBookkeepieTenureLabel(provider);
  const { visible: experienceTags, overflow: experienceOverflow } =
    buildProviderExperienceTags(provider, 3, selectedIndustry);
  const row1Tags = experienceTags.slice(0, 2);
  const row2Tags = experienceTags.slice(2, 3);

  return (
    <article className={classes.card}>
      <div className={classes.avatarWrap}>
        {provider?.providerImage ? (
          <img
            src={provider.providerImage}
            alt=""
            className={classes.avatar}
            loading="lazy"
            draggable={false}
          />
        ) : (
          <div className={classes.avatarPlaceholder} aria-hidden="true" />
        )}
      </div>

      <h2 className={classes.name}>{getQuickResultProviderDisplayName(provider)}</h2>
      {tenureLabel ? <p className={classes.tenure}>{tenureLabel}</p> : null}

      {reviewCount > 0 ? (
        <div className={classes.ratingRow}>
          <QuickResultStarRating value={reviewAvg} />
          <span className={classes.reviewCount}>({reviewCount})</span>
        </div>
      ) : null}

      {experienceTags.length > 0 ? (
        <div className={classes.tagsGrid}>
          {row1Tags.map((tag) => (
            <span key={`${stableProviderKey}-${tag.key}`} className={classes.tag}>
              <span className={classes.tagEmoji} role="img" aria-hidden="true">
                {tag.emoji}
              </span>
              <span className={classes.tagLabel}>{tag.label}</span>
            </span>
          ))}
          {row2Tags.map((tag) => (
            <span
              key={`${stableProviderKey}-${tag.key}`}
              className={classes.tag}
            >
              <span className={classes.tagEmoji} role="img" aria-hidden="true">
                {tag.emoji}
              </span>
              <span className={classes.tagLabel}>{tag.label}</span>
            </span>
          ))}
          {experienceOverflow > 0 ? (
            <span className={classes.tag}>
              <span className={classes.tagLabel}>
                + {experienceOverflow} {i18n.t("searchflow.otherindustry")}
              </span>
            </span>
          ) : null}
        </div>
      ) : null}
    </article>
  );
};

export default QuickResultProviderCard;
